export const SET_LISTE_THEMATIQUES = "SET_LISTE_THEMATIQUES";
export const SET_FOND_DE_CARTE = "SET_FOND_DE_CARTE";
export const SET_TERRITOIRE = "SET_TERRITOIRE";
export const SET_THEME1 = "SET_THEME1";
export const SET_THEME2 = "SET_THEME2";
export const SET_THEME3 = "SET_THEME3";
export const SET_LISTE_CERCLES_PROPORTIONNEL = "SET_LISTE_CERCLES_PROPORTIONNEL";
export const SET_CERCLE_PROPORTIONNEL = "SET_CERCLE_PROPORTIONNEL";
export const SET_LISTE_DES_COUCHES = "SET_LISTE_DES_COUCHES";
export const CALCULER = "CALCULER";
export const SET_AFFICHER_LEGENDE = "SET_AFFICHER_LEGENDE";
export const SET_AFFICHER_LISTE_COUCHES = "SET_AFFICHER_LISTE_COUCHES";
export const SET_CHECKTHEME = "SET_CHECKTHEME";
export const SET_ALERTE = "SET_ALERTE";
export const SET_AFFICHER_FENETRE_EXPORT = "SET_AFFICHER_FENETRE_EXPORT";

export const CALCULER_GRAPHE1="CALCULER_GRAPHE1";
export const CALCULER_GRAPHE2="CALCULER_GRAPHE2";
export const SET_JETON = "SET_JETON";